import { api } from '@/common/api';

const store = {
    namespaced: true,
    state() {
        return {
            data: []
        };
    },

    mutations: {
        setDataFromResponse(state, data) {
            state.data = data.data.data;
        },
        changeStatus(state, { status, employerId, timesheetId }) {
            const employer = state.data.find(employer => employer.id === employerId);
            const timesheet = employer.timesheets.find(timesheet => timesheet.id === timesheetId);
            timesheet.status_id = status.id;
            timesheet.status = status;
            timesheet.changed = true;
            employer.changed = true;
        },
        clearChangedStatus(state, employerId) {
            const employer = state.data.find(employer => employer.id === employerId);
            employer.timesheets.filter(timesheet => timesheet.changed).forEach(timesheet => {
                timesheet.changed = false;
            });
            employer.changed = false;
        },
        clearStore(state) {
            state.data = [];
        }
    },
    actions: {
        async get({ state, commit }, params) {
            try {
                commit('setDataFromResponse', await api.get('/timesheet/', { params }));
            } catch (e) {
                throw new Error(e);
            }
        },
        async update({ state, commit }, { employerId, positionId }) {
            const timesheets = state.data.find(employer => employer.id === employerId).timesheets.filter(timesheet => timesheet.changed);
            try {
                await api.put('/timesheet/', { timesheets, employerId, positionId });
                commit('clearChangedStatus', employerId);
            } catch (e) {
                throw new Error(e);
            }
        }
    }
};

export default store;
